import { IGenericUploadEntityCreateFieldItem } from "./generic-upload.create-entity.models";

export const GENERIC_UPLOAD_FORM_FIELDS = {
  file: "file",
  entityCreateFields: "entityCreateFields",
} as const;

export interface IGenericUploadForm {
  file?: File;
  entityCreateFields: IGenericUploadEntityCreateFieldItem[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export type TGenericUploadParsedCsvRow = { __parsed_extra?: string[] } & Record<
  string,
  string
>;

export type TGenericUploadCsvRow = Omit<
  TGenericUploadParsedCsvRow,
  "__parsed_extra"
>;

export interface IGenericUploadRowInfo {
  index: number;
  extraFields?: string[];
  row: TGenericUploadCsvRow;
}

// Format-agnostic result of parsing an uploaded file (CSV, Excel, ...) into the
// rows sent to the backend. All supported parsers normalize to this shape.
export interface IGenericUploadParseResult {
  data: IGenericUploadRowInfo[];
}
